import * as angular from 'angular';
import * as _ from 'lodash';

import { IPrintOptionsService, IStoreService } from '../../services';
import { ComponentDefinition, Dashboard } from '../../models';
import { PageOption } from '../../services/helpers/print';
import { StoreElement } from '../../stateManagement';
import { MailingJobDefinition } from '../../models/mailing/MailingJobDefinition';
import { MixedUserChoice } from '../../models/mailing/MixedUserChoice';
import { isInRecipients } from '../../models/mailing/RecipientList';

class EmailComposerController implements angular.IComponentController, angular.IOnInit, angular.IOnDestroy {
    formController: angular.IFormController;
    options: PageOption[];
    selectedItem: MailingJobDefinition;
    isLoading: boolean;
    dashboards: Dashboard[];
    recipientChoices: MixedUserChoice[];

    private _unsubscribe: () => void;

    static $inject = [
        'storeService',
        'printOptionsService',
        'dashboardActionsService'
    ];

    constructor(
        private _storeService: IStoreService,
        private _printOptionsService: IPrintOptionsService
    ) {}

    $onInit() {
        this.options = [{ name: '', configuration: null }].concat(this._printOptionsService.getOptions());
        this.isLoading = true;
        this._unsubscribe = this._storeService.register(store => {
            this.dashboards = _.values<Dashboard>(store.dashboards.dictionary)
                .sort((a, b) => a.name > b.name ? 1 : -1);
            this.isLoading = false;
        }, [
            StoreElement.Dashboards
        ]);
        this.rebuildChoices();
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['selectedItem']) {
            this.rebuildChoices();
        }
        if (changesObj['recipientChoices']) {
            this.rebuildChoices();
        }
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    private rebuildChoices() {
        if (this.selectedItem && this.selectedItem.recipients
            && this.recipientChoices && this.recipientChoices.length > 0) {
            const rebuilded = this.recipientChoices.filter(rc => isInRecipients(this.selectedItem.recipients, rc));
            this.selectedItem.selectedChoices = rebuilded;
        }
    }
}

export const wtEmailComposer: ComponentDefinition = {
    componentId: 'wtEmailComposer',
    controller: EmailComposerController,
    template: require('./emailComposer.component.html'),
    controllerAs: 'vm',
    bindings: {
        selectedItem: '<',
        formController: '=',
        recipientChoices: '<' 
    }
};